import { jsonServerRestClient, fetchUtils } from 'admin-on-rest';
import {config} from './config';

const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    const token = sessionStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);

    console.error(process.env);
    return fetchUtils.fetchJson(url, options);
}
const adminRestClient = jsonServerRestClient(`${config.API_URL}/admin`, httpClient);

export {adminRestClient}


// WEBPACK FOOTER //
// ./src/restClient.js